// Product lookup via OpenFoodFacts (free, no key).
// Tries multiple endpoints/languages to maximize data completeness.
function grade(v) {
  const s = String(v || "").toUpperCase();
  return /^[A-E]$/.test(s) ? s : null;
}

export async function lookupBarcode(code) {
  if (!/^\d{8,14}$/.test(code)) return null;
  const endpoints = [
    `https://world.openfoodfacts.org/api/v2/product/${code}.json?lc=ar`,
    `https://world.openfoodfacts.org/api/v2/product/${code}.json?lc=en`,
    `https://world.openfoodfacts.net/api/v2/product/${code}.json`,
  ];
  let p = null;
  for (const url of endpoints) {
    try {
      const r = await fetch(url);
      const d = await r.json();
      if (d.status === 1 && d.product) { p = d.product; break; }
    } catch { /* try next */ }
  }
  if (!p) return null;
  const n = p.nutriments || {};
  return {
    name: p.product_name_ar || p.product_name_en || p.product_name || p.generic_name || p.brands || code,
    brand: p.brands || null,
    image: p.image_front_url || p.image_url || p.image_small_url || p.selected_images?.front?.display?.en || null,
    quantity: p.quantity || null,
    ingredients: p.ingredients_text_ar || p.ingredients_text_en || p.ingredients_text || p.ingredients_text_with_allergens || null,
    allergens: (p.allergens_tags || []).map((t) => String(t).replace(/^\w+:/, "")).filter(Boolean),
    traces: (p.traces_tags || []).map((t) => String(t).replace(/^\w+:/, "")).filter(Boolean),
    labels: (p.labels_tags || []).map((t) => String(t).replace(/^\w+:/, "")).slice(0, 4),
    nutriscore: grade(p.nutriscore_grade || p.nutrition_grade_fr),
    nova: [1, 2, 3, 4].includes(p.nova_group) ? p.nova_group : null,
    ecoscore: grade(p.ecoscore_grade),
    nutrition: {
      kcal: n["energy-kcal_100g"] ?? n.energy_kcal_100g ?? null,
      fat: n.fat_100g ?? null,
      satFat: n["saturated-fat_100g"] ?? null,
      carbs: n.carbohydrates_100g ?? null,
      sugars: n.sugars_100g ?? null,
      protein: n.proteins_100g ?? null,
      salt: n.salt_100g ?? null,
      fiber: n.fiber_100g ?? null,
    },
    category: mapCat(p.categories_tags || []),
  };
}

function mapCat(tags) {
  const t = (tags || []).map((x) => String(x).toLowerCase()).join(" ");
  if (/beverage|drink|water|juice|soda|coffee|tea/.test(t)) return "groceries";
  if (/food|snack|dair|meat|bread|fruit|vegetable|cereal/.test(t)) return "groceries";
  if (/cosmet|beauty|hygien/.test(t)) return "personal_care";
  if (/clean|detergent|laundry/.test(t)) return "household_items";
  return "groceries";
}
